export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "BeeBrix© powered by KP Studio | Marketing Magazine 2023",
  "shortTitle": "BeeBrix© Marketing Magazine 2023",
  "description": "The BeeBrix© Marketing Magazine for 2023",
  "width": 1290,
  "height": 912,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://magazine.beebrix.com/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true,
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true,
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {
      'gal-dummy.jpg':'Holding Image',
      'dashboard.jpg':'The BeeBrix dashboard',
      'staff_register.jpg':'The Staff Register landing page',
      'staff_register_indiviuals.jpg':'The individual staff register index',
      'staff_register_new_user.jpg':'New staff member form',
      'staff_register_user.jpg':'Staff member page',
      'staff_register_skills.jpg':'Skills landing page',
      'staff_register_new_skill.jpg':'New skill form',
      'staff_register_skill.jpg':'Skill page view',
      'staff_register_roles.jpg':'User roles landing page',
      'staff_register_new_role.jpg':'New user role form',
      'staff_register_role.jpg':'User role page view',
      'staff_register_jobs.jpg':'Job tiles landing page',
      'staff_register_new_job.jpg':'New job title form',
      'staff_register_job.jpg':'Job title page view',
      'Staff-Register-Teams-1.png':'The teams index page',
      'Staff-Register-Teams-New-Team.png':'The new team form',
      'Staff-Register-Teams-Customer-Service.png':'The new customer service team page',
      'Staff-Register-Job-titles-1.png':'The job titles index',
      'Staff-Register-Job-titles-New-User-Job.png':'The new job title form',
      'Staff-Register-Job-titles-Sales-Executive.png':'The new sales executive job title page',
      'organisation_tools.jpg':'The Organisation Tools landing page',
      'organisation_tools_accidents.jpg':'The accidents index page',
      'organisation_tools_new_accident.jpg':'New accident form',
      'organisation_tools_accident.jpg':'Accident page',
      'organisation_tools_documents.jpg':'The documents index page',
      'organisation_tools_new_document.jpg':'New document form',
      'organisation_tools_document.jpg':'Document page',
      'organisation_tools_change_requests.jpg':'The change requests index page',
      'organisation_tools_new_change_request.jpg':'New change request form',
      'organisation_tools_change_request.jpg':'Change request page',
      'organisation_tools_locations.jpg':'The locations index page',
      'organisation_tools_new_location.jpg':'New location form',
      'organisation_tools_location.jpg':'Location page',
      'organisation_tools_meetings.jpg':'The meetings index page',
      'organisation_tools_new_meeting.jpg':'New meeting form',
      'organisation_tools_meeting.jpg':'Meeting page',
      'check_ins.jpg':'The users personal check ins page',
      'check_ins_break.jpg':'The users personal check ins page (on a break)',
      'check_in.jpg':'A singular check in page',
      'Dashboard-Leave-Manager.png':'The dashboard each user lands on when logging in',
      'Leave-Manager-Allowances-1.png':'The managerial leave manager view - 1',
      'Leave-Manager-Allowances-2.png':'The managerial leave manager view - 2',
      'Leave-Manager-New-absence.png':'The new absence request form',
      'Leave-Manager-David-Holidays.png':'Personal leave manager view',
      'Expenses.png':'The Expenses landing page',
      'Expenses-Pending-Requests.png':'Pending expense requests',
      'Expenses-Pending-Payments.png':'Pending expense payments',
      'Expenses-Accounts-View.png':'The expenses accounts view',
      'Expenses-Expense-Mia-Kerr.png':'An example expense request from Mia Kerr',
      'Expenses-New-Expense-Request-Mileage.png':'A new expense request form',
      'Expenses-New-Expense-Request.png':'',
      'todos.jpg':'A users personal todo list',
      'todos_new_todo.jpg':'The new todo form',
      'Expenses-PDF.png':'The PDF print out for expenses',
      'clients.jpg':'The Clients index page',
      'clients_new_client.jpg':'The new client form',
      'client.jpg':'A client page',
      'projects.jpg':'The Projects index page',
      'projects_new_project.jpg':'The new project form',
      'project.jpg':'The single project page',
      'project_report.jpg':'The project report page',
      'asset_register.jpg':'Asset register page',
      'asset_register_hardwares.jpg':'Hardware landing page',
      'asset_register_new_hardware.jpg':'New hardware form',
      'asset_register_hardware.jpg':'hardware page view',
      'asset_register_softwares.jpg':'Software landing page',
      'asset_register_new_software.jpg':'New software form',
      'asset_register_software.jpg':'Software page view',
      'asset_register_information_assets.jpg':'Information asset landing page',
      'asset_register_new_information_asset.jpg':'New information asset form',
      'asset_register_information_asset.jpg':'Information asset page view',
      'Activity-Log.png':'The Activity Log',
    },
    "fullscreenEnabled": true,
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 1-title-1" style="top:419px;left:260px;" src="/static/_content/1-title-1.png">
      <img class="abs halfScale 1-title-2" style="top:419px;left:467px;" src="/static/_content/1-title-2.png">

      <img class="abs halfScale 1-hex-1" style="top:419px;left:741px;" src="/static/_content/1-hex-1.png">
      <img class="abs halfScale 1-hex-2" style="top:378px;left:813px;" src="/static/_content/1-hex-2.png">
      <img class="abs halfScale 1-hex-3" style="top:459px;left:813px;" src="/static/_content/1-hex-3.png">
      <img class="abs halfScale 1-hex-4" style="top:501px;left:741px;" src="/static/_content/1-hex-4.png">
      <img class="abs halfScale 1-hex-5" style="top:338px;left:741px;" src="/static/_content/1-hex-5.png">
      <img class="abs halfScale 1-hex-6" style="top:298px;left:669px;" src="/static/_content/1-hex-6.png">
      <img class="abs halfScale 1-hex-7" style="top:541px;left:669px;" src="/static/_content/1-hex-7.png">
      <img class="abs halfScale 1-hex-8" style="top:338px;left:596px;" src="/static/_content/1-hex-8.png">
      <img class="abs halfScale 1-hex-9" style="top:298px;left:523px;" src="/static/_content/1-hex-9.png">

      <img class="abs halfScale 1-title-3" style="top:505px;left:262px;" src="/static/_content/1-title-3.png">

      <img class="halfScaleC pointer 1-next-1" style="top:344px;left:838px" onclick="Publish.goToNextPage()"
        src="/static/_content/1-next-1.png">
    `,
    "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
            .fromTo(cOf("1-title-1"), 0.6, {opacity:0, x: -50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.7)
            .fromTo(cOf("1-title-2"), 0.6, {opacity:0, x: 100}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.8)
            .fromTo(cOf("1-hex-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
            .fromTo(cOf("1-hex-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)
            .fromTo(cOf("1-hex-3"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)
            .fromTo(cOf("1-hex-4"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("1-hex-5"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("1-hex-6"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.7)
            .fromTo(cOf("1-hex-7"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.7)
            .fromTo(cOf("1-hex-8"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.8)
            .fromTo(cOf("1-hex-9"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("1-title-3"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.3)
            .fromTo(cOf("1-next-1"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7), onComplete: function() {
              cOf("1-next-1")[0].classList.add("halfpulsetitle")
              cOf("1-next-1")[0].classList.add("animatedpulse")
            }}, 2.8)
        }
      
        function onPageLeave() {
          pg1Anim.stop();
          cOf("1-next-1")[0].classList.remove("halfpulsetitle")
          cOf("1-next-1")[0].classList.remove("animatedpulse")
        }
      `,
    "searchText": "The BeeBrix© Marketing Magazine for 2023"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": `
      <div class="addContentLinkThree" 
      style="top:314px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(3)"></div>
      <div class="addContentLinkThree" 
      style="top:346px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(5)"></div>
      <div class="addContentLinkThree"
      style="top:376px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(7)"></div>
      <div class="addContentLinkThree"
      style="top:409px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(8)"></div>
      <div class="addContentLinkThree"
      style="top:442px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(9)"></div>
      <div class="addContentLinkThree"
      style="top:472px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(10)"></div>
      <div class="addContentLinkThree"
      style="top:502px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(11)"></div>
      <div class="addContentLinkThree"
      style="top:537px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(12)"></div>
      <div class="addContentLinkThree"
      style="top:570px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(13)"></div>
      <div class="addContentLinkThree"
      style="top:598px; left:129px; width:268px; height:28px;" onclick="Publish.goToPage(15)"></div>

      <img class="pointer halfpulse animatedpulse pointer 2-next-1" style="top:715px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/2-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        setTimeout(function(){
          addContentLinks();
        }, 1000);
      }

      function onPageLeave() {
        removeContentLinks();
      }
    `,
    "searchText": "BeeBrix© is an office adminstration application that allows  organisations to track their users in many different ways as well as providing a central hub for all HR. Use integrated systems to create Users, Teams, Clients and Projects, allowing you to manage and monitor your Workforce and Clients in real time with accurate reporting."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 3-title-1" style="top:66px;left:257px;" src="/static/_content/3-title-1.png">
      <img class="abs halfScale 3-title-2" style="top:171px;left:198px;" src="/static/_content/3-title-2.png">

      <img class="abs halfScale 3-quote-1" style="top:60px;left:892px;" src="/static/_content/3-quote-1.png">

      <img class="abs halfScaleC 3-hex" style="top:-29px;left:-42px;" src="/static/_content/3-hex-1.png">
      <img class="abs halfScaleC 3-hex" style="top:86px;left:-43px;" src="/static/_content/3-hex-2.png">
      <img class="abs halfScaleC 3-hex" style="top:434px;left:963px;" src="/static/_content/3-hex-3.png">
      <img class="abs halfScaleC 3-hex" style="top:493px;left:862px;" src="/static/_content/3-hex-4.png">
      <img class="abs halfScaleC 3-hex" style="top:550px;left:963px;" src="/static/_content/3-hex-5.png">
      <img class="abs halfScaleC 3-hex" style="top:667px;left:762px;" src="/static/_content/3-hex-6.png">
      <img class="abs halfScaleC 3-hex" style="top:-87px;left:57px;" src="/static/_content/3-hex-7.png">

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/3-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg3Anim = new TimelineMax();
        pg3Anim
          .fromTo(cOf("3-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("3-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("3-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("3-quote-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg3Anim.stop();
      }
    `,
    "searchText": "The staff register allows you to add individual staff and track their work and development,setup yourorganisations team structure and add custom job titles to your BeeBrix database. Each individual user and team will have aunique page within BeeBrix - that page contains a personal document store and a variety of data relating to each user or team. The BeeBrix application will track any changes to the profiles of individual, teams and job titles. MANAGE YOUR STAFF WITH EASE. Once a user has been created they will be available to be added to a team and to any open project - you will also be able to track their work based on their  check-ins. Organising my team has never been easier, I can locate everything I need very quickly."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": `
    <img class="abs halfScaleC 4-hex" style="top:120px;left:392px;" src="/static/_content/4-hex-1.png">
    <img class="abs halfScaleC 4-hex" style="top:59px;left:501px;" src="/static/_content/4-hex-2.png">
    <img class="abs halfScaleC 4-hex" style="top:479px;left:602px;" src="/static/_content/4-hex-3.png">
    <img class="abs halfScaleC 4-hex" style="top:419px;left:714px;" src="/static/_content/4-hex-4.png">
    <img class="abs halfScaleC 4-hex" style="top:542px;left:714px;" src="/static/_content/4-hex-5.png">

    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:216px; left:379px;" 
    onclick="Publish.openVideo('/static/_content/staff-register-user-role.mp4')" 
    src="/static/_content/4-video.png"
    >
    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:155px; left:282px;"
    onclick="pg4_role_gallery(0)" 
    src="/static/_content/4-gallery.png"
    >

    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:-14px; left:580px;"
    onclick="pg4_staff_gallery(0)" 
    src="/static/_content/4-gallery.png"
    >
    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:102px; left:578px;" 
    onclick="Publish.openVideo('/static/_content/staff-register-individual.mp4')" 
    src="/static/_content/4-video.png"
    >

    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:405px; left:495px;"
    onclick="pg4_job_gallery(0)" 
    src="/static/_content/4-gallery.png"
    >
    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:520px; left:494px;" 
    onclick="Publish.openVideo('/static/_content/staff-register-job-title.mp4')" 
    src="/static/_content/4-video.png"
    >

    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:297px; left:701px;"
    onclick="pg4_team_gallery(0)" 
    src="/static/_content/4-gallery.png"
    >
    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:355px; left:795px;" 
    onclick="Publish.openVideo('/static/_content/staff-register-team.mp4')" 
    src="/static/_content/4-video.png"
    >

    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:572px; left:798px;"
    onclick="pg4_skill_gallery(0)" 
    src="/static/_content/4-gallery.png"
    >
    <img 
    class="abs halfScaleC 4-gal-vid pointer" 
    style="top:633px; left:698px;" 
    onclick="Publish.openVideo('/static/_content/staff-register-skill.mp4')" 
    src="/static/_content/4-video.png"
    >

    <img class="abs halfScale 4-title-1" style="top:216px;left:141px;" src="/static/_content/4-title-1.png">
    <img class="abs halfScale 4-title-2" style="top:122px;left:762px;" src="/static/_content/4-title-2.png">
    <img class="abs halfScale 4-title-3" style="top:516px;left:354px;" src="/static/_content/4-title-3.png">
    <img class="abs halfScale 4-title-4" style="top:337px;left:895px;" src="/static/_content/4-title-4.png">
    <img class="abs halfScale 4-title-5" style="top:621px;left:987px;" src="/static/_content/4-title-5.png">


    <img class="halfScaleC pointer 4-next-1" style="top:711px;left:1059px" onclick="Publish.goToNextPage()"
        src="/static/_content/4-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        pg4Anim
          .staggerFromTo(cOf("4-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .staggerFromTo(cOf("4-gal-vid"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)
          .fromTo(cOf("4-title-1"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
          .fromTo(cOf("4-title-2"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.6)
          .fromTo(cOf("4-title-3"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.7)
          .fromTo(cOf("4-title-4"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.8)
          .fromTo(cOf("4-title-5"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.9)
          .fromTo(cOf("4-next-1"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1.4)

          setTimeout(function(){
            cOf("4-gal-vid")[0].classList.add("halfpulse")
            cOf("4-gal-vid")[0].classList.add("animatedpulse")
            cOf("4-gal-vid")[1].classList.add("halfpulse")
            cOf("4-gal-vid")[1].classList.add("animatedpulse")
            cOf("4-gal-vid")[2].classList.add("halfpulse")
            cOf("4-gal-vid")[2].classList.add("animatedpulse")
            cOf("4-gal-vid")[3].classList.add("halfpulse")
            cOf("4-gal-vid")[3].classList.add("animatedpulse")
            cOf("4-gal-vid")[4].classList.add("halfpulse")
            cOf("4-gal-vid")[4].classList.add("animatedpulse")
            cOf("4-gal-vid")[5].classList.add("halfpulse")
            cOf("4-gal-vid")[5].classList.add("animatedpulse")
            cOf("4-gal-vid")[6].classList.add("halfpulse")
            cOf("4-gal-vid")[6].classList.add("animatedpulse")
            cOf("4-gal-vid")[7].classList.add("halfpulse")
            cOf("4-gal-vid")[7].classList.add("animatedpulse")
            cOf("4-gal-vid")[8].classList.add("halfpulse")
            cOf("4-gal-vid")[8].classList.add("animatedpulse")
            cOf("4-gal-vid")[9].classList.add("halfpulse")
            cOf("4-gal-vid")[9].classList.add("animatedpulse")
            cOf("4-next-1")[0].classList.add("halfpulse")
            cOf("4-next-1")[0].classList.add("animatedpulse")
          }, 3000)
      }
    
      function onPageLeave() {
        pg4Anim.stop();
        cOf("4-gal-vid")[0].classList.remove("halfpulse")
        cOf("4-gal-vid")[0].classList.remove("animatedpulse")
        cOf("4-gal-vid")[1].classList.remove("halfpulse")
        cOf("4-gal-vid")[1].classList.remove("animatedpulse")
        cOf("4-gal-vid")[2].classList.remove("halfpulse")
        cOf("4-gal-vid")[2].classList.remove("animatedpulse")
        cOf("4-gal-vid")[3].classList.remove("halfpulse")
        cOf("4-gal-vid")[3].classList.remove("animatedpulse")
        cOf("4-gal-vid")[4].classList.remove("halfpulse")
        cOf("4-gal-vid")[4].classList.remove("animatedpulse")
        cOf("4-gal-vid")[5].classList.remove("halfpulse")
        cOf("4-gal-vid")[5].classList.remove("animatedpulse")
        cOf("4-gal-vid")[6].classList.remove("halfpulse")
        cOf("4-gal-vid")[6].classList.remove("animatedpulse")
        cOf("4-gal-vid")[7].classList.remove("halfpulse")
        cOf("4-gal-vid")[7].classList.remove("animatedpulse")
        cOf("4-gal-vid")[8].classList.remove("halfpulse")
        cOf("4-gal-vid")[8].classList.remove("animatedpulse")
        cOf("4-gal-vid")[9].classList.remove("halfpulse")
        cOf("4-gal-vid")[9].classList.remove("animatedpulse")
        cOf("4-next-1")[0].classList.remove("halfpulse")
        cOf("4-next-1")[0].classList.remove("animatedpulse")
      }
    `,
    "searchText": "TEAM REGISTER INDIVIDUAL REGISTER  SKILLS MATRIX  4"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 5-title-1" style="top:94px;left:235px;" src="/static/_content/5-title-1.png">
      <img class="abs halfScale 5-title-2" style="top:169px;left:422px;" src="/static/_content/5-title-2.png">

      <img class="abs halfScale 5-quote-1" style="top:60px;left:892px;" src="/static/_content/5-quote-1.png">

      <img class="abs halfScaleC 5-hex" style="top:-89px;left:57px;" src="/static/_content/5-hex-1.png">
      <img class="abs halfScaleC 5-hex" style="top:666px;left:761px;" src="/static/_content/5-hex-2.png">
      <img class="abs halfScaleC 5-hex" style="top:434px;left:963px;" src="/static/_content/5-hex-3.png">
      <img class="abs halfScaleC 5-hex" style="top:493px;left:862px;" src="/static/_content/5-hex-4.png">
      <img class="abs halfScaleC 5-hex" style="top:550px;left:963px;" src="/static/_content/5-hex-5.png">
      <img class="abs halfScaleC 5-hex" style="top:378px;left:1065px;" src="/static/_content/5-hex-6.png">

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/5-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg5Anim = new TimelineMax();
        pg5Anim
          .fromTo(cOf("5-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("5-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("5-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("5-quote-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg5Anim.stop();
      }
    `,
    "searchText": "BeeBrix offers a variety of organisational tools to help record, track and analyse your companies staff, location and work. BeeBrix allows you to create company locations that will link into your staff and assets - this means you can get real-time data on your team members, and their activity, in relation to their current location when checked-in.    You can also log critical information pertaining to your business changes and internal events. BeeBrix provides a simple way to record any accidents and meetings that happen within your company as well as any organisational change requests. This simple, auditable data will be essential when trying to obtain various accreditations."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScaleC 6-hex" style="top:120px;left:392px;" src="/static/_content/6-hex-1.png">
      <img class="abs halfScaleC 6-hex" style="top:59px;left:501px;" src="/static/_content/6-hex-2.png">
      <img class="abs halfScaleC 6-hex" style="top:479px;left:602px;" src="/static/_content/6-hex-3.png">
      <img class="abs halfScaleC 6-hex" style="top:419px;left:714px;" src="/static/_content/6-hex-4.png">
      <img class="abs halfScaleC 6-hex" style="top:542px;left:714px;" src="/static/_content/6-hex-5.png">

      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:216px; left:379px;" 
      onclick="Publish.openVideo('/static/_content/organisation-tools-accident.mp4')" 
      src="/static/_content/6-video.png"
      >
      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:155px; left:282px;"
      onclick="pg6_accident_gallery(0)" 
      src="/static/_content/6-gallery.png"
      >

      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:-14px; left:580px;"
      onclick="pg6_document_gallery(0)" 
      src="/static/_content/6-gallery.png"
      >
      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:102px; left:578px;" 
      onclick="Publish.openVideo('/static/_content/organisation-tools-document.mp4')" 
      src="/static/_content/6-video.png"
      >

      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:405px; left:495px;"
      onclick="pg6_change_request_gallery(0)" 
      src="/static/_content/6-gallery.png"
      >
      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:520px; left:494px;" 
      onclick="Publish.openVideo('/static/_content/organisation-tools-change-request.mp4')" 
      src="/static/_content/6-video.png"
      >

      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:297px; left:701px;"
      onclick="pg6_location_gallery(0)" 
      src="/static/_content/6-gallery.png"
      >
      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:355px; left:795px;" 
      onclick="Publish.openVideo('/static/_content/organisation-tools-location.mp4')" 
      src="/static/_content/6-video.png"
      >

      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:572px; left:798px;"
      onclick="pg6_meeting_gallery(0)" 
      src="/static/_content/6-gallery.png"
      >
      <img 
      class="abs halfScaleC 6-gal-vid pointer" 
      style="top:633px; left:698px;" 
      onclick="Publish.openVideo('/static/_content/organisation-tools-meeting.mp4')" 
      src="/static/_content/6-video.png"
      >

      <img class="abs halfScale 6-title-1" style="top:216px;left:67px;" src="/static/_content/6-title-1.png">
      <img class="abs halfScale 6-title-2" style="top:122px;left:762px;" src="/static/_content/6-title-2.png">
      <img class="abs halfScale 6-title-3" style="top:519px;left:82px;" src="/static/_content/6-title-3.png">
      <img class="abs halfScale 6-title-4" style="top:337px;left:895px;" src="/static/_content/6-title-4.png">
      <img class="abs halfScale 6-title-5" style="top:621px;left:987px;" src="/static/_content/6-title-5.png">


      <img class="halfScaleC pointer 6-next-1" style="top:711px;left:1059px" onclick="Publish.goToNextPage()"
          src="/static/_content/6-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg6Anim = new TimelineMax();
        pg6Anim
          .staggerFromTo(cOf("6-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .staggerFromTo(cOf("6-gal-vid"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)
          .fromTo(cOf("6-title-1"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
          .fromTo(cOf("6-title-2"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.6)
          .fromTo(cOf("6-title-3"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.7)
          .fromTo(cOf("6-title-4"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.8)
          .fromTo(cOf("6-title-5"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.9)
          .fromTo(cOf("6-next-1"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 1.4)

          setTimeout(function(){
            cOf("6-gal-vid")[0].classList.add("halfpulse")
            cOf("6-gal-vid")[0].classList.add("animatedpulse")
            cOf("6-gal-vid")[1].classList.add("halfpulse")
            cOf("6-gal-vid")[1].classList.add("animatedpulse")
            cOf("6-gal-vid")[2].classList.add("halfpulse")
            cOf("6-gal-vid")[2].classList.add("animatedpulse")
            cOf("6-gal-vid")[3].classList.add("halfpulse")
            cOf("6-gal-vid")[3].classList.add("animatedpulse")
            cOf("6-gal-vid")[4].classList.add("halfpulse")
            cOf("6-gal-vid")[4].classList.add("animatedpulse")
            cOf("6-gal-vid")[5].classList.add("halfpulse")
            cOf("6-gal-vid")[5].classList.add("animatedpulse")
            cOf("6-gal-vid")[6].classList.add("halfpulse")
            cOf("6-gal-vid")[6].classList.add("animatedpulse")
            cOf("6-gal-vid")[7].classList.add("halfpulse")
            cOf("6-gal-vid")[7].classList.add("animatedpulse")
            cOf("6-gal-vid")[8].classList.add("halfpulse")
            cOf("6-gal-vid")[8].classList.add("animatedpulse")
            cOf("6-gal-vid")[9].classList.add("halfpulse")
            cOf("6-gal-vid")[9].classList.add("animatedpulse")
            cOf("6-next-1")[0].classList.add("halfpulse")
            cOf("6-next-1")[0].classList.add("animatedpulse")
          }, 3000)
      }
    
      function onPageLeave() {
        pg6Anim.stop();
        cOf("6-gal-vid")[0].classList.remove("halfpulse")
        cOf("6-gal-vid")[0].classList.remove("animatedpulse")
        cOf("6-gal-vid")[1].classList.remove("halfpulse")
        cOf("6-gal-vid")[1].classList.remove("animatedpulse")
        cOf("6-gal-vid")[2].classList.remove("halfpulse")
        cOf("6-gal-vid")[2].classList.remove("animatedpulse")
        cOf("6-gal-vid")[3].classList.remove("halfpulse")
        cOf("6-gal-vid")[3].classList.remove("animatedpulse")
        cOf("6-gal-vid")[4].classList.remove("halfpulse")
        cOf("6-gal-vid")[4].classList.remove("animatedpulse")
        cOf("6-gal-vid")[5].classList.remove("halfpulse")
        cOf("6-gal-vid")[5].classList.remove("animatedpulse")
        cOf("6-gal-vid")[6].classList.remove("halfpulse")
        cOf("6-gal-vid")[6].classList.remove("animatedpulse")
        cOf("6-gal-vid")[7].classList.remove("halfpulse")
        cOf("6-gal-vid")[7].classList.remove("animatedpulse")
        cOf("6-gal-vid")[8].classList.remove("halfpulse")
        cOf("6-gal-vid")[8].classList.remove("animatedpulse")
        cOf("6-gal-vid")[9].classList.remove("halfpulse")
        cOf("6-gal-vid")[9].classList.remove("animatedpulse")
        cOf("6-next-1")[0].classList.remove("halfpulse")
        cOf("6-next-1")[0].classList.remove("animatedpulse")
      }
    `,
    "searchText": "TEAM REGISTER INDIVIDUAL REGISTER  SKILLS MATRIX  4"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 7-title-1" style="top:44px;left:488px;" src="/static/_content/7-title-1.png">
      <img class="abs halfScale 7-title-2" style="top:148px;left:398px;" src="/static/_content/7-title-2.png">

      <img class="abs halfScale 7-quote-1" style="top:631px;left:34px;" src="/static/_content/7-quote-1.png">

      <img class="abs halfScaleC 7-hex" style="top:86px;left:157px;" src="/static/_content/7-hex-1.png">
      <img class="abs halfScaleC 7-hex" style="top:-31px;left:962px;" src="/static/_content/7-hex-2.png">

      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:185px; left:46px;" 
        onclick="Publish.openVideo('/static/_content/check-ins.mp4')" 
        src="/static/_content/7-video.png"
      >
      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:378px; left:44px;"
        onclick="pg7_gallery(0)" 
        src="/static/_content/7-gallery.png"
      >

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/7-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg7Anim = new TimelineMax();
        pg7Anim
          .fromTo(cOf("7-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("7-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("7-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("7-quote-1"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg7Anim.stop();
      }
    `,
    "searchText": "When a staff member 'checks in' on BeeBrix a record is created logging the time, the project they are checking in to and the task within that project they are working on (if applicable). If a new check in is started, the previous check in will automatically close. Users are able to view all of their own check ins, see data regarding their total check in time for the day, along with the current week, and also view their personal check ins within a project (if accessing via the project page). This gives each user detailed insight to their working patterns. Managers have access to even more detailed data regarding check ins. They can overview check-ins from a number of positions within the app to make their analysis work for them. TRACK YOUR TEAM. I now know exactly who is checked in, where they are and what they are working on."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 8-title-1" style="top:164px;left:479px;" src="/static/_content/8-title-1.png">
      <img class="abs halfScale 8-title-2" style="top:270px;left:255px;" src="/static/_content/8-title-2.png">

      <img class="abs halfScale 8-quote-1" style="top:44px;left:913px;" src="/static/_content/8-quote-1.png">

      <img class="abs halfScaleC 8-hex" style="top:-30px;left:158px;" src="/static/_content/8-hex-1.png">
      <img class="abs halfScaleC 8-hex" style="top:145px;left:58px;" src="/static/_content/8-hex-2.png">

      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:333px; left:1011px;" 
        onclick="Publish.openVideo('/static/_content/leave-manager.mp4')" 
        src="/static/_content/8-video.png"
      >
      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:525px; left:1011px;"
        onclick="pg8_gallery(0)" 
        src="/static/_content/8-gallery.png"
      >

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/8-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg8Anim = new TimelineMax();
        pg8Anim
          .fromTo(cOf("8-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("8-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("8-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("8-quote-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg8Anim.stop();
      }
    `,
    "searchText": "From each staff members personal dashboard they can request holidays, see pending leave requests and also see any requests that have already been approved. They can also access their full leave manager page where they can see further details and statistics regarding their leave. Team leaders/senior staff will be able to access the managerial leave manager. This will allow them to see a full calendar detailing the organisations current staffing levels - this can be filtered by team. A FULLY DIGITAL REQUEST AND APPROVAL SYSTEM. The leave manager being integrated with all of our staff has saved us a lot of admin time"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 9-title-1" style="top:143px;left:458px;" src="/static/_content/9-title-1.png">

      <img class="abs halfScale 9-quote-1" style="top:42px;left:57px;" src="/static/_content/9-quote-1.png">

      <img class="abs halfScaleC 9-hex" style="top:86px;left:963px;" src="/static/_content/9-hex-1.png">
      <img class="abs halfScaleC 9-hex" style="top:665px;left:156px;" src="/static/_content/9-hex-2.png">

      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:337px; left:14px;" 
        onclick="Publish.openVideo('/static/_content/expenses.mp4')" 
        src="/static/_content/9-video.png"
      >
      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:529px; left:14px;"
        onclick="pg9_gallery(0)" 
        src="/static/_content/9-gallery.png"
      >

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/9-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg9Anim = new TimelineMax();
        pg9Anim
          .fromTo(cOf("9-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("9-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("9-quote-1"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg9Anim.stop();
      }
    `,
    "searchText": "From each staff members dashboard/homepage they can make expense claims. These can be either a millage claim where they record millage and reason for trip, or another expense where they will record the item and then upload an image of the receipt. Expenses will be approved by a Senior Member of Staff and reports can be printed as PDF or CSV. PAYMENTS MADE EASY. I can view and action all of our expenses quickly - we’ve reduced our process time by 90%."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 10-title-1" style="top:89px;left:244px;" src="/static/_content/10-title-1.png">
      <img class="abs halfScale 10-title-2" style="top:199px;left:444px;" src="/static/_content/10-title-2.png">

      <img class="abs halfScale 10-quote-1" style="top:61px;left:839px;" src="/static/_content/10-quote-1.png">

      <img class="abs halfScaleC 10-hex" style="top:83px;left:-46px;" src="/static/_content/10-hex-1.png">
      <img class="abs halfScaleC 10-hex" style="top:722px;left:658px;" src="/static/_content/10-hex-2.png">

      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:302px; left:903px;" 
        onclick="Publish.openVideo('/static/_content/todos.mp4')" 
        src="/static/_content/10-video.png"
      >
      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:494px; left:903px;"
        onclick="pg10_gallery(0)" 
        src="/static/_content/10-gallery.png"
      >

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/10-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg10Anim = new TimelineMax();
        pg10Anim
          .fromTo(cOf("10-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("10-title-2"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("10-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("10-quote-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg10Anim.stop();
      }
    `,
    "searchText": "TODOS  “Todos can be set both personally and for any users who you manage. A todo can be marked as priority and given a deadline with relevant indicators highlighting their status. Managers/project leaders can view any todos they have set for their staff. PRODUCTIVITY MADE EASY. I use the todos widget everyday, both personally” and to allocate tasks to my team."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": `
        <img class="abs halfScale 11-title-1" style="top:54px;left:309px;" src="/static/_content/11-title-1.png">
        <img class="abs halfScale 11-title-2" style="top:162px;left:384px;" src="/static/_content/11-title-2.png">

        <img class="abs halfScale 11-quote-1" style="top:36px;left:911px;" src="/static/_content/11-quote-1.png">

        <img class="abs halfScaleC 11-hex" style="top:27px;left:57px;" src="/static/_content/11-hex-1.png">
        <img class="abs halfScaleC 11-hex" style="top:666px;left:761px;" src="/static/_content/11-hex-2.png">

        <img 
          class="abs halfpulse animatedpulse pointer" 
          style="top:221px; left:976px;" 
          onclick="Publish.openVideo('/static/_content/clients.mp4')" 
          src="/static/_content/11-video.png"
        >
        <img 
          class="abs halfpulse animatedpulse pointer" 
          style="top:413px; left:976px;"
          onclick="pg11_gallery(0)" 
          src="/static/_content/11-gallery.png"
        >

        <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
          src="/static/_content/11-next-1.png">
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim
            .fromTo(cOf("11-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .staggerFromTo(cOf("11-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
            .fromTo(cOf("11-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("11-quote-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
        }
      
        function onPageLeave() {
          pg11Anim.stop();
        }
      `,
    "searchText": "BeeBrix allows you to create a database for all your clients. You can save all of their contact information, attach any related documents, make any notes regarding your clients and track any historical changes all within the application. You can also link your clients to any project you have created through BeeBrix, creating a dynamic database connection. When viewing your clients BeeBrix page you will see a list of any associated projects and their current status. This intuitive navigation system, and quick access to analytical data, will allow you to easily manage all of your clients from one place. A DYNAMIC RELATIONSHIP. Having all my client details at my fingertips is a huge time saver."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": `
        <img class="abs halfScale 12-title-1" style="top:141px;left:662px;" src="/static/_content/12-title-1.png">
        <img class="abs halfScale 12-title-2" style="top:229px;left:507px;" src="/static/_content/12-title-2.png">

        <img class="abs halfScale 12-quote-1" style="top:58px;left:71px;" src="/static/_content/12-quote-1.png">

        <img class="abs halfScaleC 12-hex" style="top:376px;left:1064px;" src="/static/_content/12-hex-1.png">
        <img class="abs halfScaleC 12-hex" style="top:721px;left:255px;" src="/static/_content/12-hex-2.png">

        <img 
          class="abs halfpulse animatedpulse pointer" 
          style="top:347px; left:32px;" 
          onclick="Publish.openVideo('/static/_content/projects.mp4')" 
          src="/static/_content/12-video.png"
        >
        <img 
          class="abs halfpulse animatedpulse pointer" 
          style="top:540px; left:32px;"
          onclick="pg12_gallery(0)" 
          src="/static/_content/12-gallery.png"
        >

        <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
          src="/static/_content/12-next-1.png">
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim
            .fromTo(cOf("12-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .staggerFromTo(cOf("12-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
            .fromTo(cOf("12-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("12-quote-1"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
        }
      
        function onPageLeave() {
          pg12Anim.stop();
        }
      `,
    "searchText": "When you create a project on BeeBrix you can assign a number of variables to help you track the project quickly and simply, from start to finish. You can setup your project as a one off fixed project or a monthly project, link the project to a client, add members, attach documents, set the estimated completion time and price as well as set the project status, saving historical projects into your database as they reach completion. ANALYSIS MADE EASY As your project progresses, and your team register check-ins, you will see your indicators change accordingly feeding you live data on your clocked hours, hourly rate and whether you are currently under or over budget. Data can be aggregated into PDF reports, using customisable filters, for both single and multiple projects. Projects dynamically linking to our clients makes tracking and analysis a breeze."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 13-title-1" style="top:66px;left:257px;" src="/static/_content/13-title-1.png">
      <img class="abs halfScale 13-title-2" style="top:171px;left:198px;" src="/static/_content/13-title-2.png">

      <img class="abs halfScale 13-quote-1" style="top:60px;left:892px;" src="/static/_content/13-quote-1.png">

      <img class="abs halfScaleC 13-hex" style="top:-29px;left:-42px;" src="/static/_content/13-hex-1.png">
      <img class="abs halfScaleC 13-hex" style="top:86px;left:-43px;" src="/static/_content/13-hex-2.png">
      <img class="abs halfScaleC 13-hex" style="top:493px;left:863px;" src="/static/_content/13-hex-3.png">
      <img class="abs halfScaleC 13-hex" style="top:665px;left:759px;" src="/static/_content/13-hex-4.png">

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/13-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg13Anim = new TimelineMax();
        pg13Anim
          .fromTo(cOf("13-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("13-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("13-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("13-quote-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg13Anim.stop();
      }
    `,
    "searchText": "The asset register allows you to log and track all of your organisations IT assets - approved software, hardware and information assets. Logging all of your assets will greatly help when trying to gain accreditations. The BeeBrix asset register not only details every element of your asset, but also tracks historical changes making them fully auditable. TRUST US, WE’RE ACCREDITED. The asset register helped us attain our ISO accrediation which in turn helped us attract new clientele."
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": `
    <img class="abs halfScaleC 14-hex" style="top:382px;left:526px;" src="/static/_content/14-hex-1.png">
    <img class="abs halfScaleC 14-hex" style="top:301px;left:690px;" src="/static/_content/14-hex-2.png">
    <img class="abs halfScaleC 14-hex" style="top:471px;left:693px;" src="/static/_content/14-hex-3.png">

    <img 
    class="abs halfScaleC 14-gal-vid pointer" 
    style="top:462px; left:438px;" 
    onclick="Publish.openVideo('/static/_content/asset-register-software.mp4')" 
    src="/static/_content/14-video.png"
    >
    <img 
    class="abs halfScaleC 14-gal-vid pointer" 
    style="top:346px; left:438px;"
    onclick="pg14_software_gallery(0)" 
    src="/static/_content/14-gallery.png"
    >

    <img 
    class="abs halfScaleC 14-gal-vid pointer" 
    style="top:196px; left:724px;"
    onclick="pg14_information_asset_gallery(0)" 
    src="/static/_content/14-gallery.png"
    >
    <img 
    class="abs halfScaleC 14-gal-vid pointer" 
    style="top:257px; left:821px;" 
    onclick="Publish.openVideo('/static/_content/asset-register-information-asset.mp4')" 
    src="/static/_content/14-video.png"
    >

    <img 
    class="abs halfScaleC 14-gal-vid pointer" 
    style="top:560px; left:822px;"
    onclick="pg14_hardware_gallery(0)" 
    src="/static/_content/14-gallery.png"
    >
    <img 
    class="abs halfScaleC 14-gal-vid pointer" 
    style="top:615px; left:722px;" 
    onclick="Publish.openVideo('/static/_content/asset-register-hardware.mp4')" 
    src="/static/_content/14-video.png"
    >

    <img class="abs halfScale 14-title-1" style="top:437px;left:173px;" src="/static/_content/14-title-1.png">
    <img class="abs halfScale 14-title-2" style="top:211px;left:905px;" src="/static/_content/14-title-2.png">
    <img class="abs halfScale 14-title-3" style="top:555px;left:937px;" src="/static/_content/14-title-3.png">


    <img class="halfScaleC pointer 14-next-1" style="top:711px;left:1059px" onclick="Publish.goToNextPage()"
        src="/static/_content/14-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg14Anim = new TimelineMax();
        pg14Anim
          .staggerFromTo(cOf("14-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .staggerFromTo(cOf("14-gal-vid"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7), onComplete: function() {
            cOf("14-gal-vid")[0].classList.add("halfpulse")
            cOf("14-gal-vid")[0].classList.add("animatedpulse")
            cOf("14-gal-vid")[1].classList.add("halfpulse")
            cOf("14-gal-vid")[1].classList.add("animatedpulse")
            cOf("14-gal-vid")[2].classList.add("halfpulse")
            cOf("14-gal-vid")[2].classList.add("animatedpulse")
            cOf("14-gal-vid")[3].classList.add("halfpulse")
            cOf("14-gal-vid")[3].classList.add("animatedpulse")
            cOf("14-gal-vid")[4].classList.add("halfpulse")
            cOf("14-gal-vid")[4].classList.add("animatedpulse")
            cOf("14-gal-vid")[5].classList.add("halfpulse")
            cOf("14-gal-vid")[5].classList.add("animatedpulse")
          }}, 0.1, 1.4)
          .fromTo(cOf("14-title-1"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
          .fromTo(cOf("14-title-2"), 0.6, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.1)
          .fromTo(cOf("14-title-3"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.3)
          .fromTo(cOf("14-next-1"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7), onComplete: function() {
            cOf("14-next-1")[0].classList.add("halfpulse")
            cOf("14-next-1")[0].classList.add("animatedpulse")
          }}, 1.4)
      }
    
      function onPageLeave() {
        pg14Anim.stop();
        cOf("14-gal-vid")[0].classList.remove("halfpulse")
        cOf("14-gal-vid")[0].classList.remove("animatedpulse")
        cOf("14-gal-vid")[1].classList.remove("halfpulse")
        cOf("14-gal-vid")[1].classList.remove("animatedpulse")
        cOf("14-gal-vid")[2].classList.remove("halfpulse")
        cOf("14-gal-vid")[2].classList.remove("animatedpulse")
        cOf("14-gal-vid")[3].classList.remove("halfpulse")
        cOf("14-gal-vid")[3].classList.remove("animatedpulse")
        cOf("14-gal-vid")[4].classList.remove("halfpulse")
        cOf("14-gal-vid")[4].classList.remove("animatedpulse")
        cOf("14-gal-vid")[5].classList.remove("halfpulse")
        cOf("14-gal-vid")[5].classList.remove("animatedpulse")
        cOf("14-next-1")[0].classList.remove("halfpulse")
        cOf("14-next-1")[0].classList.remove("animatedpulse")
      }
    `,
    "searchText": "INFORMATION ASSETS APPROVED SOFTWARE  HARDWARE  12"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": `
      <img class="abs halfScale 15-title-1" style="top:134px;left:190px;" src="/static/_content/15-title-1.png">
      <img class="abs halfScale 15-title-2" style="top:237px;left:516px;" src="/static/_content/15-title-2.png">

      <img class="abs halfScale 15-quote-1" style="top:61px;left:839px;" src="/static/_content/15-quote-1.png">

      <img class="abs halfScaleC 15-hex" style="top:85px;left:-43px;" src="/static/_content/15-hex-1.png">
      <img class="abs halfScaleC 15-hex" style="top:725px;left:661px;" src="/static/_content/15-hex-2.png">

      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:302px; left:902px;" 
        onclick="Publish.openVideo('/static/_content/activity-log.mp4')" 
        src="/static/_content/15-video.png"
      >
      <img 
        class="abs halfpulse animatedpulse pointer" 
        style="top:493px; left:902px;"
        onclick="pg15_gallery(0)" 
        src="/static/_content/15-gallery.png"
      >

      <img class="halfScaleC pointer halfpulse animatedpulse pointer 2-next-1" style="top:725px;left:1063px" onclick="Publish.goToNextPage()"
        src="/static/_content/15-next-1.png">
    `,
    "script": `
      function onPageEnter() {
        pg15Anim = new TimelineMax();
        pg15Anim
          .fromTo(cOf("15-title-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("15-hex"), 0.3, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)
          .fromTo(cOf("15-title-2"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("15-quote-1"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
      }
    
      function onPageLeave() {
        pg15Anim.stop();
      }
    `,
    "searchText": "Every action taken, by any user, is tracked and logged in Beebrix making it fully auditable. Having a fully auditable application can assist in getting accreditations. Tracking all actions provides large amounts of analytical data that is displayed, and can be extracted, in various ways and give you valuiable insight into your organisations working patterns and processes. READY FOR AUDIT. The activity tracker helped us pass our audit and achieve a higher level accreditation"
  }],[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": `

    <img class="abs halfScale kp-spotlight-p-4" style="top:223px;left:502px;" src="/static/_content/16-logo-1-4.png">
    <img class="abs halfScale kp-spotlight-p-3" style="top:223px;left:502px;" src="/static/_content/16-logo-1-3.png">
    <img class="abs halfScale kp-spotlight-p-2" style="top:223px;left:502px;" src="/static/_content/16-logo-1-2.png">
    <img class="abs halfScale kp-spotlight-p-1" style="top:223px;left:502px;" src="/static/_content/16-logo-1-1.png">
    
    <img class="abs halfScale" style="top:223px;left:432px;" src="/static/_content/16-logo-1.png">

    

    <img class="abs halfScaleC 16-logo" style="top:617px;left:566px;" src="/static/_content/16-logo-2.png">
    <img class="abs halfScaleC 16-logo" style="top:611px;left:637px;" src="/static/_content/16-logo-3.png">

    <a href="mailto:sales@kpstudio.co.uk" class="addContentLink" style="top:512px;left:563px;width:190px;height:24px;"></a>
    <a href="tel:01604889452" class="addContentLink" style="top:537px;left:509px;width:130px;height:24px;"></a>
    `,
    "script": `
      function onPageEnter() {
        pg16Anim = new TimelineMax();
        pg16Anim
          .fromTo(cOf("kp-spotlight-p-1"), 0.4, {opacity:0, x: 0}, {opacity: 1, x: 20, ease: Power2.easeOut}, 1)
          .fromTo(cOf("kp-spotlight-p-2"), 0.8, {opacity:0, x: 0}, {opacity: 1, x: 40, ease: Power2.easeOut}, 1)
          .fromTo(cOf("kp-spotlight-p-3"), 1.4, {opacity:0, x: 0}, {opacity: 1, x: 60, ease: Power2.easeOut}, 1)
          .fromTo(cOf("kp-spotlight-p-4"), 2, {opacity:0, x: 0}, {opacity: 1, x: 80, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("16-logo"), 0.6, {scale: 0}, {scale: 0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 0.3, 2.4)
      }
    
      function onPageLeave() {
        pg16Anim.stop();
        removeContentLinks();
      }
    `,
    "searchText": "Did you enjoy this digital magazine? Email sales@kpstudio.co.uk or call 01604 889 452 for more information. KP Studio Ltd ©2023"
  }]],
  "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))
        
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) { 
          return e.className = 'addContentLinkThree'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function animateNumbers(klass, delay = 1, stagger = 0.3) {
        numbers = cOf(klass)
      
        setTimeout(function() {
          for (let i = 0; i < numbers.length; i++) {
            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])
          }
        }, delay * 1000)
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function pg4_staff_gallery(index) {
        Publish.openGalleryTwo([['staff_register.jpg', 'staff_register_individuals.jpg', 'staff_register_new_user.jpg', 'staff_register_user.jpg'], index])
      }
      function pg4_team_gallery(index) {
        Publish.openGalleryTwo([['staff_register.jpg', 'Staff-Register-Teams-1.png', 'Staff-Register-Teams-New-Team.png', 'Staff-Register-Teams-Customer-Service.png'], index])
      }
      function pg4_skill_gallery(index) {
        Publish.openGalleryTwo([['staff_register.jpg', 'staff_register_skills.jpg', 'staff_register_new_skill.jpg', 'staff_register_skill.jpg'], index])
      }
      function pg4_role_gallery(index) {
        Publish.openGalleryTwo([['staff_register.jpg', 'staff_register_roles.jpg', 'staff_register_new_role.jpg', 'staff_register_role.jpg'], index])
      }
      function pg4_job_gallery(index) {
        Publish.openGalleryTwo([['staff_register.jpg', 'staff_register_jobs.jpg', 'staff_register_new_job.jpg', 'staff_register_job.jpg'], index])
      }

      function pg6_accident_gallery(index) {
        Publish.openGalleryTwo([['organisation_tools.jpg', 'organisation_tools_accidents.jpg', 'organisation_tools_new_accident.jpg', 'organisation_tools_accident.jpg'], index])
      }

      function pg6_document_gallery(index) {
        Publish.openGalleryTwo([['organisation_tools.jpg', 'organisation_tools_documents.jpg', 'organisation_tools_new_document.jpg', 'organisation_tools_document.jpg'], index])
      }

      function pg6_change_request_gallery(index) {
        Publish.openGalleryTwo([['organisation_tools.jpg', 'organisation_tools_change_requests.jpg', 'organisation_tools_new_change_request.jpg', 'organisation_tools_change_request.jpg'], index])
      }

      function pg6_location_gallery(index) {
        Publish.openGalleryTwo([['organisation_tools.jpg', 'organisation_tools_locations.jpg', 'organisation_tools_new_location.jpg', 'organisation_tools_location.jpg'], index])
      }

      function pg6_meeting_gallery(index) {
        Publish.openGalleryTwo([['organisation_tools.jpg', 'organisation_tools_meetings.jpg', 'organisation_tools_new_meeting.jpg', 'organisation_tools_meeting.jpg'], index])
      }

      function pg7_gallery(index) {
        Publish.openGalleryTwo([['check_ins.jpg', 'check_ins_break.jpg', 'check_in.jpg'], index])
      }
      function pg8_gallery(index) {
        Publish.openGalleryTwo([['dashboard.jpg', 'Leave-Manager-Allowances-1.png', 'Leave-Manager-Allowances-2.png', 'Leave-Manager-New-absence.png', 'Leave-Manager-David-Holidays.png'], index])
      }
      function pg9_gallery(index) {
        Publish.openGalleryTwo([['Expenses.png', 'Expenses-Pending-Requests.png', 'Expenses-Pending-Payments.png', 'Expenses-Accounts-View.png', 'Expenses-Expense-Mia-Kerr.png', 'Expenses-New-Expense-Request-Mileage.png', 'Expenses-New-Expense-Request.png', 'Expenses-PDF.png'], index])
      }
      function pg10_gallery(index) {
        Publish.openGalleryTwo([['dashboard.jpg', 'todos.jpg', 'todos_new_todo.jpg'], index])
      }
      function pg11_gallery(index) {
        Publish.openGalleryTwo([['clients.jpg', 'clients_new_client.jpg', 'client.jpg'], index])
      }
      function pg12_gallery(index) {
        Publish.openGalleryTwo([['projects.jpg', 'projects_new_project.jpg', 'project.jpg', 'project_report.jpg'], index])
      }
      function pg14_software_gallery(index) {
        Publish.openGalleryTwo([['asset_register.jpg', 'asset_register_softwares.jpg', 'asset_register_new_software.jpg', 'asset_register_software.jpg'], index])
      }
      function pg14_hardware_gallery(index) {
        Publish.openGalleryTwo([['asset_register.jpg', 'asset_register_hardwares.jpg', 'asset_register_new_hardware.jpg', 'asset_register_hardware.jpg'], index])
      }
      function pg14_information_asset_gallery(index) {
        Publish.openGalleryTwo([['asset_register.jpg', 'asset_register_information_assets.jpg', 'asset_register_new_information_asset.jpg', 'asset_register_information_asset.jpg'], index])
      }
      function pg15_gallery(index) {
        Publish.openGalleryTwo([['Activity-Log.png'], index])
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }



// WEBPACK FOOTER //
// ./src/document.js